<template>
	<div class="flex xs-12 wrap">
		<div class="flex xs-12 bb1 bc7 xs-left p4 xs-middle">
			<span class="fs3 fw4 mr2">{{ $t("select_form") }}</span>
			<j-base-select
				class="xs-3"
				v-model="selectedForm"
				:options="formOptions"
			/>
		</div>

		<div class="flex wrap xs-12">
			<component :is="selectedForm" />
		</div>

		<!-- God Mode -->
		<div
			class="xs-12 p1 ta3 bg4"
			style="position:fixed; bottom:0; right: 0; z-index:100;"
			@click="
				$store.commit(
					'caseManagement/SET_GOD_MODE',
					!$store.state.caseManagement.isGodMode
				)
			"
		>
			<span class="tt2 fs2 c6 fw7 cu2">
				God Mode is
				{{ $store.state.caseManagement.isGodMode == true ? "On" : "Off" }}
			</span>
		</div>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect"

import { i18n } from "@/locales/setup.js"
import CaseInsured from "./Forms/CaseInsured/"
import CaseHolder from "./Forms/CaseHolder/"
import CaseBeneficiaries from "./Forms/CaseBeneficiaries/"

export default {
	components: {
		JBaseSelect,
		CaseInsured,
		CaseHolder,
		CaseBeneficiaries
	},

	data() {
		return {
			selectedForm: null,
			formOptions: [
				{
					name: this.t("insured"),
					value: "CaseInsured"
				},
				{
					name: this.t("holder"),
					value: "CaseHolder"
				},
				{
					name: this.t("beneficiaries"),
					value: "CaseBeneficiaries"
				}
			]
		}
	},

	methods: {
		t(key) {
			const locale = {
				"en-US": {
					insured: "Insured",
					holder: "Holder",
					beneficiaries: "Beneficiaries"
				},

				"zh-CN": {
					insured: "Insured",
					holder: "Holder",
					beneficiaries: "Beneficiaries"
				}
			}
			return locale[i18n.locale][key]
		}
	},

	created() {
		this.selectedForm = this.formOptions?.[0]?.value
	}
}
</script>
